import { Component, Input, OnChanges } from '@angular/core';

import { PerformanceProfilingService } from './performance-profiling.service';

@Component({
    selector: 'ms-performance-tracker',
    template: ` <img width="1" height="1" [src]="imgSrc" (load)="trackPerformance()" /> `,
})
export class PerformanceTrackerComponent implements OnChanges {
    @Input() trigger = '';

    imgSrc = '';

    private readonly pixels = [
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==',
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
    ];

    private currentPixel = 0;

    constructor(private perfProfilingService: PerformanceProfilingService) {}

    ngOnChanges(): void {
        this.imgSrc = this.pixels[this.currentPixel];
        // eslint-disable-next-line no-bitwise
        this.currentPixel = this.currentPixel ^ 1;
    }

    trackPerformance(): void {
        this.perfProfilingService.markTTI();
    }
}
